export default __webpack_public_path__ + "static/media/saturn.7b5afe47.png";